const skillInfos = [
    {
        title: 'Advanced',
        skills: ['HTML', 'CSS', 'Javascript']
    },

    {
        title: 'Medium',
        skills: ['React JS', 'SASS', 'Figma', 'NPM', 'GIT']
    },

    {
        title: 'Beginner',
        skills: ['Blender', 'Illustrator', 'Photoshop']
    }
];

export default skillInfos;